webpackJsonp([24],{

/***/ 510:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(18);

var _reactStatic = __webpack_require__(12);

__webpack_require__(510);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SESSION_IMAGES = {
  1: 'https://a.storyblok.com/f/42340/1080x1080/a9714d949f/0.jpg',
  2: 'https://a.storyblok.com/f/42340/1080x1080/88454074fd/1.jpg',
  3: 'https://a.storyblok.com/f/42340/1080x1080/d863233bb4/2.jpg  ',
  4: 'https://a.storyblok.com/f/42340/1080x1080/692f5ba183/3.jpg',
  5: 'https://a.storyblok.com/f/42340/1080x1080/f1788531c5/4.jpg',
  6: 'https://a.storyblok.com/f/42340/1080x1080/a4a270b801/5.jpg',
  7: 'https://a.storyblok.com/f/42340/1080x1080/0efdfe9854/purpose.jpg',
  8: 'https://a.storyblok.com/f/42340/1080x1080/3d641b91bf/6.jpg',
  9: 'https://a.storyblok.com/f/42340/1080x1080/8b04447787/7.jpg',
  10: 'https://a.storyblok.com/f/42340/1080x1080/f661eb839e/myanmar.jpg',
  11: 'https://a.storyblok.com/f/42340/1080x1080/720bca3348/10.jpg',
  12: 'https://a.storyblok.com/f/42340/1080x1080/3ead6c0751/12.jpg',
  13: 'https://a.storyblok.com/f/42340/1080x1080/647ce26291/9.jpg',
  14: 'https://a.storyblok.com/f/42340/1080x1080/33a26ca115/aspen.jpg',
  15: 'https://a.storyblok.com/f/42340/1080x1080/72bec6c4fc/11.jpg'
};

var AGENDA = [{
  date: 'Monday, July 6th',
  sessions: [{
    title: 'Innovation Week Opening Ceremony',
    imageNumber: 1,
    time: '9:00 AM ET / 10:00 PYT',
    description: 'Welcome to the Poverty Stoplight Innovation Week!\n\nThe opening ceremony includes an intimate conversation with Dr. Martin Burt, Founder and CEO of Fundación Paraguaya and The Poverty Stoplight.\n\nIn dialogue with Rodrigo París, Latin American Social Changemaker, Philanthropist and Journalist.\n\nSession held in Spanish with live audio translation in English.',
    registerHref: 'https://luma.com/k6kopru1'
  }, {
    title: 'Civic Tech and Social Impact',
    imageNumber: 2,
    time: '11:00 AM ET / 12:00 PYT',
    description: 'This session explores how civic technology can advance transparency, accountability, and measurable social impact.\n\nFeaturing Oluseun Onigbinde, co-founder of BudgIT and a leading advocate for fiscal transparency, open governance, and citizen engagement across Africa, and Julia Corvalan, PhD, Global Operations Manager at Poverty Stoplight and an international development expert focused on scaling social technologies in vulnerable communities, the conversation will examine how digital tools can empower citizens, strengthen institutions, and support community-led change.\n\nTogether, the speakers will discuss what it takes to design civic tech that is inclusive, practical, and rooted in real-world impact — moving from data access to deeper participation, trust, and accountability.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/mhgltkk4'
  }, {
    title: 'Overperformance, Burnout, and Our Overdependence on Technology',
    imageNumber: 3,
    time: '1:00 PM ET / 14:00 PYT',
    description: 'This conversation explores chronic overperformance, burnout, and the growing role of screens, devices, and digital tools in shaping how we work, strive, compare, and disconnect.\n\nDrawing on themes from Life. Reclaimed: Find Freedom from Chronic Overperformance, Pippa Grange, a performance psychologist, culture coach, author, and ethical leadership fellow who has worked with elite teams and performers around the world, will reflect on how to keep the human at the center of ambition and achievement.\n\nIn dialogue with Julia Corvalan, PhD, Global Operations Manager at Poverty Stoplight and an international development expert focused on grassroots innovation and social technology, the session will consider how individuals and organizations can move away from unsustainable patterns of overperformance and toward more intentional, humane, and resilient ways of living and working.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/ktt6gfl8'
  }]
}, {
  date: 'Tuesday, July 7th',
  sessions: [{
    title: 'A Human-First, AI-Enabled Approach to Fighting Poverty',
    imageNumber: 4,
    time: '8:00 AM ET / 9:00 PYT',
    description: 'This session explores how artificial intelligence can help turn insight into action, strengthen human agency, and accelerate the journey to ending extreme poverty.\n\nFeaturing Zahid Torres-Rahman of Business Fights Poverty, the conversation will draw on the organization’s work as a global community of 30,000 professionals advancing lives, livelihoods, and access to learning.\n\nWith more than 30 years of experience building partnerships for social impact, Zahid brings a practical perspective on how trusted relationships, knowledge-sharing, and collaboration can be strengthened by AI. The session will also explore Business Fights Poverty’s 2025 development of AI tools that connect people with thousands of resources and a Global Expert Network of more than 200 professionals.\n\nThe conversation will consider how AI can support poverty alleviation while keeping people, their dignity, agency, expertise, and lived experience, at the center.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/jl2f2ooz'
  }, {
    title: 'Poverty Stoplight Innovation: Progress and Next Steps',
    imageNumber: 5,
    time: '10:00 AM ET / 11:00 PYT',
    description: 'This recap session will highlight the latest technology updates across the Poverty Stoplight ecosystem, including improvements in data visualization, the AI chatbot, and the digital platform.\n\nGuido Ruiz Díaz and Fabrizio Núñez of Fundación Paraguaya will share recent progress, key learnings, and next steps for strengthening the tools that support partners, practitioners, and families in turning data into action.\n\nSession held in Spanish with live audio translation in English.',
    registerHref: 'https://luma.com/6ovjnre9'
  }]
}, {
  date: 'Wednesday, July 8th',
  sessions: [{
    title: 'Poverty Stoplight Tech for MFIs',
    imageNumber: 6,
    time: '7:00 AM ET / 8:00 PYT',
    description: 'Microfinance works best when it is part of a broader strategy that helps families build capabilities, dignity, and agency.\n\nThis session will explore how Poverty Stoplight technology can help microfinance institutions move beyond repayment rates alone and focus on whether families are measurably improving their lives.\n\nIn conversation with Larry Reed of Thrive Lights, Luis Fernando Sanabria of Fundación Paraguaya will be joined by Smita Bhatnagar and Salma Kagadi of SEWA in India to discuss how digital tools, household-level data, and family-centered coaching can strengthen microfinance programs.\n\nTogether, they will explore how institutions can better understand clients’ multidimensional realities, support more targeted action, and use technology to make financial inclusion more closely connected to poverty alleviation and long-term wellbeing.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/kr88bxww'
  }, {
    title: 'Purpose-Driven Leadership in Business and in Life',
    imageNumber: 7,
    time: '10:30 AM ET / 11:30 PYT',
    description: 'As a part of Poverty Stoplight Innovation Week, please join us for an intimate conversation with Raul Gauto, Paraguayan Social Changemaker, Environmentalist, and Entrepreneur.\n\nHe will be interviewed by Luis Fernando Sanabria, COO at Fundación Paraguaya. This candid exchange will cover Raul’s remarkable trajectory across the Latin American social impact space, building ecosystems and communities of care with Avina for decades, establishing the Mbaracayu Forest Reserve in Paraguay with support of The Nature Conservancy, and more recently, bringing the Poverty Stoplight across forestry value chains in Paraguay through his triple bottomline business, Forestal Sylvis. Unmissable!\n\nSession will be held in Spanish with simultaneous English audio translation.',
    registerHref: 'https://luma.com/ppb1fl94'
  }, {
    title: 'The Human-Centered Approach in the Time of AI',
    imageNumber: 8,
    time: '12:00 PM ET / 13:00 PYT',
    description: 'As artificial intelligence accelerates new possibilities for development, financial inclusion, and service delivery, this session asks a critical question: how do we ensure that technology strengthens human agency rather than replacing it?\n\nIn conversation with Julia Corvalan, of Poverty Stoplight, Eric Kaduru of CARE USA will explore what it means to take a human-centered approach to digital transformation in communities that have historically been underserved by formal systems.\n\nDrawing on his work as Senior Technical Director for Strategic Partnerships, Digital Inclusion, and Inclusive Finance, Eric will share insights from his approach which begins with local demand, trust, and community realities, then works outward to design partnerships, data systems, identity frameworks, and financial linkages that can scale without losing ownership or context.\n\nTogether, Julia and Eric will discuss how AI and digital tools can support inclusive economic ecosystems when designed around people first, strengthening resilience, governance, and opportunity for women and underserved communities.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/t6pgyc52'
  }, {
    title: 'Robust Poverty LLMs that Support Poverty Elimination',
    imageNumber: 9,
    time: '3:00 PM ET / 16:00 PYT',
    description: 'The past decade has been marked by a decline in support and funding for initiatives in the humanitarian and development sector, best exemplified by the dismantling of USAID in early 2025. These trends have left knowledge and funding gaps that further highlight the need for new approaches in addressing global poverty.\n\nWe deployed a novel, integrated approach for finetuning a foundational large language model on a diverse range of international development data, with the hope that this work could be used as a policymaking tool to better inform more effective poverty and development solutions.\n\nRobert Krueger and Esther Mao of Worcester Polytechnic Institute will share work connected to inste^d, an AI-driven platform designed to help policymakers and aid organizations better understand multidimensional poverty and identify more targeted, evidence-based interventions. Drawing on WPI’s interdisciplinary strengths in social science, policy, data science, and project-based research, the session will examine how large language models and diverse international development datasets can support more effective poverty diagnosis, policy design, and resource allocation.\n\nRather than relying only on income-based measures or top-down assumptions, this conversation will focus on how AI can help surface patterns, context, and community priorities in ways that strengthen human agency and improve decision-making. Participants will consider both the promise and responsibility of using AI as a tool for more responsive, beneficiary-centered poverty alleviation.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/90ykpdwx'
  }]
}, {
  date: 'Thursday, July 9th',
  sessions: [
  // {
  //   title: 'VisionFund Myanmar Special Bonus Session',
  //   imageNumber: 10,
  //   time: '6:00 PYT',
  //   description:
  //     'A special bonus session featuring Seng Bu Manam, interviewed by Martin Burt.\n\nSession held in English with live audio translation in Spanish.',
  //   registerHref: '#',
  // },
  {
    title: 'New Stoplight Mobile App',
    imageNumber: 11,
    time: '9:00 AM ET / 10:00 PYT',
    description: 'This practical session will introduce partners to the new Stoplight Mobile App, highlighting its key improvements and walking through the survey-taking and synchronization flow.\n\nGuido Ruiz Díaz and Fabrizio Núñez of Fundación Paraguaya will guide implementation teams through what has changed, how the app supports fieldwork, and what partners should know as they begin using it.\n\nThe session will also provide space for feedback, questions, and shared learning from teams working directly with families and communities.\n\nSession held in Spanish with live audio translation in English.',
    registerHref: 'https://luma.com/il7kc91b'
  }, {
    title: 'Familiarising Yourself with Data (and Why That’s Not as Scary as You Think)',
    imageNumber: 12,
    time: '11:00 AM ET / 12:00 PYT',
    description: 'Data can feel intimidating: technical, abstract, and reserved for experts. But at its core, data is simply evidence: facts, observations, conversations, survey responses, patterns, and stories that can help us better understand the people and communities we serve.\n\nIn this session, Ibrahima Ball, Program Data Analyst for International Programs at Unbound, and Davide Gallo, founder of Vetta, will explore how civil society organizations can build confidence in using data without losing sight of the human realities behind it.\n\nDrawing on Ibrahima’s experience connecting program data with the lived experiences of families, and Davide’s work helping entrepreneurs use AI to test ideas and build more effectively, the conversation will show how data can become a practical tool for learning, decision-making, and impact.\n\nTogether, they will discuss how to start with meaningful questions, interpret evidence with context, avoid common traps, and use data to test assumptions rather than follow it blindly. Participants will leave with a simple, human-centered approach to using data: ask, look for evidence, interpret with context, decide, and learn.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/t2uhdhvb'
  }, {
    title: 'Tech Innovation Ecosystem in Latin America',
    imageNumber: 13,
    time: '1:00 PM ET / 14:00 PYT',
    description: 'This session explores the evolving technology innovation ecosystem in Latin America, with a focus on entrepreneurship, investment, and regional trends.\n\nIn conversation with Julia Corvalan, Gabi Cibils and Vivianne Bernardes-Cibils of Cibersons will share perspectives from their work across venture capital, technology, and cross-border innovation.\n\nVivianne brings more than 35 years of experience as a technology pioneer, investor, serial entrepreneur, and Co-Founder of Cibersons, a multinational tech and investment firm. Gaby, who manages venture capital at Cibersons, brings experience from Paraguay’s tech ecosystem, Silicon Valley startups and investors, and early-stage investment across the Americas.\n\nTogether, they will discuss the opportunities, challenges, and collaborations shaping the future of tech innovation in Latin America.\n\nSession held in Spanish with live audio translation in English.',
    registerHref: 'https://luma.com/2g63q08g'
  }]
}, {
  date: 'Friday, July 10th',
  sessions: [{
    title: 'Aspen Global Innovators "Kitchen Table" Conversation',
    imageNumber: 14,
    time: '8:00 AM ET / 9:00 PYT',
    description: 'This “kitchen table” conversation brings together Aspen New Voices Fellows for a candid exchange on what is happening across the global development and social impact sectors — and where they are finding hope.\n\nConvened by Julia Corvalan of Poverty Stoplight, the session will feature Elsa D’Silva of Red Dot Foundation/Safecity, Sathya Raghu of Soul Forest and Kheyti, Oluseun Onigbinde of BudgIT, and Carl Manlan of AGRA in a cross-sector discussion spanning gender justice, food security, civic technology, financial inclusion, poverty alleviation, and community-led change.\n\nDrawing on their work across Africa, Asia, Latin America, and global institutions, the speakers will reflect on the challenges shaping the sector today, the innovations and movements that deserve more attention, and the forms of leadership, collaboration, and imagination needed for the road ahead.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/mapgjnkk'
  }, {
    title: 'Gender, Poverty, and the Way Forward: Development work and the power of micro-transformations from the bottom-up',
    imageNumber: 15,
    time: '10:00 AM ET / 11:00 PYT',
    description: 'This conversation will explore the relationship between gender, poverty, and social change, with a focus on how bottom-up approaches can create meaningful “micro-transformations” in people’s lives and communities.\n\nFeatured guest Professor Emeritus Naila Kabeer of the London School of Economics and Political Science will bring her renowned expertise on gender, development, empowerment, and social justice to a discussion on what it takes to advance more inclusive and transformative development practice.\n\nIn conversation with Dr. Julia Corvalan of Poverty Stoplight and the International Development University in Paraguay, and Yvette Torres-Rahman, Co-founder and CFO of Business Fights Poverty, the session will examine how development work can better recognize women’s agency, lived experience, and everyday pathways out of poverty.\n\nTogether, they will reflect on the changes — large and small, individual and collective — that can help build more equitable futures from the bottom up.\n\nSession held in English with live audio translation in Spanish.',
    registerHref: 'https://luma.com/wlkox9om'
  }]
}];

var CalendarIcon = function CalendarIcon() {
  return _react2.default.createElement(
    'svg',
    {
      viewBox: '0 0 564.47 564.47',
      width: '48',
      height: '48',
      fill: '#177a3e',
      'aria-hidden': 'true'
    },
    _react2.default.createElement('path', { d: 'M472.57,78.39h-30.95v20.23c0,32.33-26.31,58.64-58.64,58.64s-58.59-26.31-58.59-58.64v-20.23h-84.29v20.23c0,32.33-26.31,58.64-58.64,58.64s-58.59-26.31-58.59-58.64v-20.23h-30.95c-31.06,0-56.27,25.2-56.27,56.27v344.46c0,31.06,25.2,56.27,56.27,56.27h380.66c31.06,0,56.27-25.2,56.27-56.27V134.66c0-31.06-25.2-56.27-56.27-56.27ZM488.76,468.34c0,15.31-12.44,27.75-27.75,27.75H103.45c-15.31,0-27.75-12.44-27.75-27.75v-235.79c0-15.31,12.44-27.69,27.75-27.69h357.56c15.31,0,27.75,12.38,27.75,27.69v235.79Z' }),
    _react2.default.createElement('path', { d: 'M181.44,127.75c16.08,0,29.13-13.04,29.13-29.13v-40.46c0-8.01-3.26-15.26-8.51-20.56-5.31-5.25-12.55-8.51-20.62-8.51-16.03,0-29.07,13.04-29.07,29.07v40.46c0,16.08,13.04,29.13,29.07,29.13Z' }),
    _react2.default.createElement('path', { d: 'M382.97,127.75c16.08,0,29.13-13.04,29.13-29.13v-40.46c0-8.01-3.26-15.26-8.51-20.56-5.31-5.25-12.55-8.51-20.62-8.51-16.03,0-29.07,13.04-29.07,29.07v40.46c0,16.08,13.04,29.13,29.07,29.13Z' }),
    _react2.default.createElement('path', { d: 'M191.12,246.97h-49.8c-6.36,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.2,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' }),
    _react2.default.createElement('path', { d: 'M307.13,246.97h-49.8c-6.41,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.14,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' }),
    _react2.default.createElement('path', { d: 'M423.15,246.97h-49.8c-6.41,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.14,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' }),
    _react2.default.createElement('rect', {
      x: '129.76',
      y: '326.73',
      width: '72.9',
      height: '47.42',
      rx: '11.55',
      ry: '11.55'
    }),
    _react2.default.createElement('path', { d: 'M307.13,326.73h-49.8c-6.41,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.14,11.55,11.55,11.55h49.8c6.36,0,11.55-5.2,11.55-11.55v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' }),
    _react2.default.createElement('path', { d: 'M423.15,326.73h-49.8c-6.41,0-11.55,5.2-11.55,11.55v24.32c0,6.36,5.14,11.55,11.55,11.55h49.8c6.36,0,11.55-5.2,11.55-11.55v-24.32c0-6.36-5.2-11.55-11.55-11.55Z' }),
    _react2.default.createElement('path', { d: 'M191.12,406.54h-49.8c-6.36,0-11.55,5.14-11.55,11.55v24.32c0,6.36,5.2,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.41-5.2-11.55-11.55-11.55Z' }),
    _react2.default.createElement('path', { d: 'M307.13,406.54h-49.8c-6.41,0-11.55,5.14-11.55,11.55v24.32c0,6.36,5.14,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.41-5.2-11.55-11.55-11.55Z' }),
    _react2.default.createElement('path', { d: 'M423.15,406.54h-49.8c-6.41,0-11.55,5.14-11.55,11.55v24.32c0,6.36,5.14,11.5,11.55,11.5h49.8c6.36,0,11.55-5.14,11.55-11.5v-24.32c0-6.41-5.2-11.55-11.55-11.55Z' })
  );
};

var ClockIcon = function ClockIcon() {
  return _react2.default.createElement(
    'svg',
    {
      viewBox: '0 0 564.47 564.47',
      width: '18',
      height: '18',
      fill: '#177a3e',
      'aria-hidden': 'true',
      className: 'iw-clock-icon'
    },
    _react2.default.createElement('path', { d: 'M282.21,25.24C140.31,25.24,25.27,140.33,25.27,282.23s115.04,256.99,256.94,256.99,256.99-115.04,256.99-256.99S424.16,25.24,282.21,25.24ZM282.21,510.29c-125.95,0-228.06-102.11-228.06-228.06S156.26,54.17,282.21,54.17s228.06,102.11,228.06,228.06-102.11,228.06-228.06,228.06Z' }),
    _react2.default.createElement('path', { d: 'M282.21,83.24c-109.88,0-198.99,89.11-198.99,198.99s89.11,198.99,198.99,198.99,198.99-89.06,198.99-198.99-89.06-198.99-198.99-198.99ZM308.93,291.46l-7.15-2.46c-2.8,8.17-10.49,13.97-19.57,13.97-11.45,0-20.73-9.28-20.73-20.73,0-2.56.48-4.98,1.35-7.25l-15.51-5.8-82.78-104.62,104.62,82.78,5.8,15.51c2.22-.87,4.69-1.35,7.25-1.35,7.3,0,13.72,3.77,17.4,9.47l6.33-4.06,99.98.34-96.98,24.21Z' })
  );
};

var PointerIcon = function PointerIcon() {
  return _react2.default.createElement('img', {
    src: 'https://a.storyblok.com/f/42340/300x300/e9147fa833/icono-12.svg',
    alt: 'Register for the Poverty Stoplight Innovation Week session',
    className: 'iw-pointer-icon'
  });
};

var CloseIcon = function CloseIcon() {
  return _react2.default.createElement(
    'svg',
    { viewBox: '0 0 24 24', width: '20', height: '20', 'aria-hidden': 'true' },
    _react2.default.createElement('path', {
      fill: 'currentColor',
      d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
    })
  );
};

var SessionLightbox = function (_React$Component) {
  _inherits(SessionLightbox, _React$Component);

  function SessionLightbox(props) {
    _classCallCheck(this, SessionLightbox);

    var _this = _possibleConstructorReturn(this, (SessionLightbox.__proto__ || Object.getPrototypeOf(SessionLightbox)).call(this, props));

    _this.state = { closing: false };

    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleOverlayClick = _this.handleOverlayClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(SessionLightbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = 'hidden';
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.closeTimer) window.clearTimeout(this.closeTimer);
      if (typeof document !== 'undefined') {
        document.body.style.overflow = '';
      }
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      var _this2 = this;

      this.setState({ closing: true });
      this.closeTimer = window.setTimeout(function () {
        _this2.props.onClose();
      }, 220);
    }
  }, {
    key: 'handleOverlayClick',
    value: function handleOverlayClick(event) {
      if (event.target === event.currentTarget) {
        this.handleClose();
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.handleClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var session = this.props.session;
      var closing = this.state.closing;


      if (!session) return null;

      var descriptionText = session.description || '';
      var paragraphs = descriptionText.split(/\n+/).filter(Boolean);
      var lightboxLastParagraph = paragraphs[paragraphs.length - 1] || '';
      var lightboxLanguageInfo = lightboxLastParagraph;

      return _react2.default.createElement(
        'div',
        {
          className: 'iw-lightbox-overlay' + (closing ? ' iw-lightbox-overlay--closing' : ''),
          onClick: this.handleOverlayClick,
          onKeyDown: this.handleKeyDown,
          role: 'dialog',
          'aria-modal': 'true',
          'aria-labelledby': 'iw-lightbox-title',
          tabIndex: -1
        },
        _react2.default.createElement(
          'div',
          {
            className: 'iw-lightbox iw-lightbox--no-image' + (closing ? ' iw-lightbox--closing' : ''),
            role: 'document'
          },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'iw-lightbox__close',
              onClick: this.handleClose,
              'aria-label': 'Close'
            },
            _react2.default.createElement(CloseIcon, null)
          ),
          _react2.default.createElement(
            'div',
            { className: 'iw-lightbox__body' },
            session.time ? _react2.default.createElement(
              'span',
              { className: 'iw-lightbox__time-pill' },
              _react2.default.createElement(ClockIcon, null),
              session.time
            ) : null,
            _react2.default.createElement(
              'h2',
              { id: 'iw-lightbox-title', className: 'iw-lightbox__title' },
              session.title
            ),
            _react2.default.createElement(
              'div',
              { className: 'iw-lightbox__description' },
              _react2.default.createElement(
                'p',
                { className: 'iw-lightbox__description-label' },
                'Description'
              ),
              paragraphs.map(function (paragraph, index) {
                return lightboxLanguageInfo && index === paragraphs.length - 1 ? null : _react2.default.createElement(
                  'p',
                  {
                    key: 'lb-p-' + index,
                    className: 'iw-lightbox__description-text'
                  },
                  paragraph
                );
              })
            ),
            lightboxLanguageInfo ? _react2.default.createElement(
              'div',
              { className: 'iw-session-language' },
              _react2.default.createElement(
                'div',
                { className: 'iw-session-language-content' },
                _react2.default.createElement(
                  'span',
                  { className: 'iw-session-language-primary' },
                  lightboxLanguageInfo
                )
              )
            ) : null,
            _react2.default.createElement(
              'div',
              { className: 'iw-lightbox__actions' },
              _react2.default.createElement(
                'a',
                {
                  className: 'iw-register-btn-wrap',
                  href: session.registerHref,
                  target: '_blank',
                  rel: 'noopener noreferrer'
                },
                _react2.default.createElement(
                  'span',
                  { className: 'iw-register-btn' },
                  'Click here to register'
                ),
                _react2.default.createElement(PointerIcon, null)
              )
            )
          )
        )
      );
    }
  }]);

  return SessionLightbox;
}(_react2.default.Component);

var InnovationWeek = function (_React$Component2) {
  _inherits(InnovationWeek, _React$Component2);

  function InnovationWeek(props) {
    _classCallCheck(this, InnovationWeek);

    var _this3 = _possibleConstructorReturn(this, (InnovationWeek.__proto__ || Object.getPrototypeOf(InnovationWeek)).call(this, props));

    _this3.state = { activeSession: null };
    _this3.openSession = _this3.openSession.bind(_this3);
    _this3.closeSession = _this3.closeSession.bind(_this3);
    return _this3;
  }

  _createClass(InnovationWeek, [{
    key: 'openSession',
    value: function openSession(session) {
      this.setState({ activeSession: session });
    }
  }, {
    key: 'closeSession',
    value: function closeSession() {
      this.setState({ activeSession: null });
    }
  }, {
    key: 'renderSessionCard',
    value: function renderSessionCard(session, key, sessionNumber) {
      var _this4 = this;

      var description = session.description || '';
      var words = description.split(/\s+/).filter(Boolean);
      var hasLongDescription = words.length > 50;
      var paragraphs = description.split(/\n+/).filter(Boolean);
      var sessionImage = SESSION_IMAGES[session.imageNumber] || SESSION_IMAGES[1];

      var lastParagraph = paragraphs[paragraphs.length - 1] || '';
      var languageInfo = lastParagraph;

      return _react2.default.createElement(
        'article',
        { key: key, className: 'iw-session' },
        _react2.default.createElement(
          'div',
          { className: 'iw-session-image-wrap' },
          _react2.default.createElement('img', {
            className: 'iw-session-image',
            src: sessionImage,
            alt: session.title
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'iw-session-body' },
          _react2.default.createElement(
            'h3',
            { className: 'iw-session-title' },
            session.title
          ),
          session.time ? _react2.default.createElement(
            'div',
            { className: 'iw-session-time-pill' },
            _react2.default.createElement(ClockIcon, null),
            _react2.default.createElement(
              'span',
              null,
              session.time
            )
          ) : null,
          description ? _react2.default.createElement(
            'div',
            { className: 'iw-session-description-preview' },
            _react2.default.createElement(
              'p',
              { className: 'iw-session-description-label' },
              'Description'
            ),
            function () {
              var remainingWords = 50;
              var truncated = false;
              return paragraphs.map(function (paragraph, index) {
                if (truncated) return null;
                var paragraphWords = paragraph.split(/\s+/).filter(Boolean);
                var displayed = paragraph;
                var isTruncated = false;
                if (hasLongDescription) {
                  if (paragraphWords.length <= remainingWords) {
                    remainingWords -= paragraphWords.length;
                  } else {
                    displayed = paragraphWords.slice(0, remainingWords).join(' ');
                    isTruncated = true;
                    truncated = true;
                  }
                }
                return _react2.default.createElement(
                  'p',
                  {
                    key: 'card-p-' + index,
                    className: 'iw-session-description-text'
                  },
                  displayed,
                  isTruncated ? _react2.default.createElement(
                    'span',
                    { className: 'iw-session-description-ellipsis' },
                    displayed.endsWith('.') ? '…' : ' …'
                  ) : null
                );
              }).filter(Boolean);
            }()
          ) : null,
          languageInfo ? _react2.default.createElement(
            'div',
            { className: 'iw-session-language' },
            _react2.default.createElement(
              'div',
              { className: 'iw-session-language-content' },
              _react2.default.createElement(
                'span',
                { className: 'iw-session-language-primary' },
                languageInfo
              )
            )
          ) : null,
          _react2.default.createElement(
            'div',
            { className: 'iw-session-actions' },
            hasLongDescription ? _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'iw-read-more-btn',
                onClick: function onClick() {
                  return _this4.openSession(session);
                }
              },
              'Read more',
              _react2.default.createElement(
                'svg',
                {
                  viewBox: '0 0 24 24',
                  width: '14',
                  height: '14',
                  'aria-hidden': 'true'
                },
                _react2.default.createElement('path', {
                  fill: 'currentColor',
                  d: 'M5 12h12.17l-3.58-3.59L15 7l6 6-6 6-1.41-1.41L17.17 14H5z'
                })
              )
            ) : null,
            _react2.default.createElement(
              'a',
              {
                className: 'iw-register-btn-wrap iw-register-btn-wrap--inline',
                href: session.registerHref,
                target: '_blank',
                rel: 'noopener noreferrer'
              },
              _react2.default.createElement(
                'span',
                { className: 'iw-register-btn' },
                'Click here to register'
              ),
              _react2.default.createElement(PointerIcon, null)
            )
          )
        )
      );
    }
  }, {
    key: 'renderDay',
    value: function renderDay(day, key, sessionOffset) {
      var _this5 = this;

      return _react2.default.createElement(
        'section',
        { key: key, className: 'iw-day' },
        _react2.default.createElement(
          'header',
          { className: 'iw-day-header' },
          _react2.default.createElement(
            'span',
            { className: 'iw-day-icon' },
            _react2.default.createElement(CalendarIcon, null)
          ),
          _react2.default.createElement(
            'h2',
            { className: 'iw-day-date' },
            day.date
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'iw-sessions' },
          day.sessions.map(function (session, index) {
            return _this5.renderSessionCard(session, key + '-session-' + index, sessionOffset + index + 1);
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var storyName = this.props.story && this.props.story.name;
      var title = storyName || 'Innovation Week 2026';
      var pageTitle = title + ' | Poverty Stoplight';
      var description = 'Join the Poverty Stoplight Innovation Week 2026 (July 6–10), a free virtual event with the Global Stoplight Network exploring data and storytelling, technology and AI, and poverty elimination around the world.';
      var keywords = 'Poverty Stoplight, Innovation Week, Innovation Week 2026, poverty elimination, social innovation, civic tech, AI for good, Global Stoplight Network, Fundación Paraguaya, data storytelling';
      var canonicalUrl = 'https://www.povertystoplight.org/en/innovation-week';
      var ogImage = 'https://a.storyblok.com/f/42340/2000x666/0e6d3a9263/innovation_week.jpg';

      var eventStructuredData = {
        '@context': 'https://schema.org',
        '@type': 'Event',
        name: title,
        description: description,
        startDate: '2026-07-06',
        endDate: '2026-07-10',
        eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
        eventStatus: 'https://schema.org/EventScheduled',
        image: ogImage,
        url: canonicalUrl,
        location: {
          '@type': 'VirtualLocation',
          url: canonicalUrl
        },
        organizer: {
          '@type': 'Organization',
          name: 'Poverty Stoplight',
          url: 'https://www.povertystoplight.org'
        }
      };

      var fullSlug = this.props.story && this.props.story.full_slug || '';
      var locale = fullSlug.indexOf('es/') === 0 ? 'es' : 'en';
      var relatedLinks = locale === 'es' ? [{ to: 'es/what-it-is', label: '¿Qué es el Semáforo de Pobreza?' }, { to: 'es/how-it-works', label: 'Cómo funciona' }, { to: 'es/impact', label: 'Nuestro impacto' }, { to: 'es/where-we-work', label: 'Dónde trabajamos' }, { to: 'es/webinars', label: 'Webinars' }, { to: 'es/news', label: 'Noticias' }, { to: 'es/partners', label: 'Aliados' }, { to: 'es/join', label: 'Únete a la red' }] : [{ to: 'en/what-it-is', label: 'What is the Poverty Stoplight?' }, { to: 'en/how-it-works', label: 'How it works' }, { to: 'en/impact', label: 'Our impact' }, { to: 'en/where-we-work', label: 'Where we work' }, { to: 'en/webinars', label: 'Webinars' }, { to: 'en/news', label: 'News' }, { to: 'en/partners', label: 'Partners' }, { to: 'en/join', label: 'Join the network' }];

      var activeSession = this.state.activeSession;


      return _react2.default.createElement(
        'div',
        { className: 'innovation-page' },
        _react2.default.createElement(
          _reactHelmet.Helmet,
          null,
          _react2.default.createElement(
            'title',
            null,
            pageTitle
          ),
          _react2.default.createElement('meta', { name: 'description', content: description }),
          _react2.default.createElement('meta', { name: 'keywords', content: keywords }),
          _react2.default.createElement('link', { rel: 'canonical', href: canonicalUrl }),
          _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
          _react2.default.createElement('meta', { property: 'og:site_name', content: 'Poverty Stoplight' }),
          _react2.default.createElement('meta', { property: 'og:title', content: pageTitle }),
          _react2.default.createElement('meta', { property: 'og:description', content: description }),
          _react2.default.createElement('meta', { property: 'og:url', content: canonicalUrl }),
          _react2.default.createElement('meta', { property: 'og:image', content: ogImage }),
          _react2.default.createElement('meta', { property: 'og:image:width', content: '2000' }),
          _react2.default.createElement('meta', { property: 'og:image:height', content: '666' }),
          _react2.default.createElement('meta', {
            property: 'og:image:alt',
            content: 'Poverty Stoplight Innovation Week'
          }),
          _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
          _react2.default.createElement('meta', { name: 'twitter:title', content: pageTitle }),
          _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
          _react2.default.createElement('meta', { name: 'twitter:image', content: ogImage }),
          _react2.default.createElement(
            'script',
            { type: 'application/ld+json' },
            JSON.stringify(eventStructuredData)
          )
        ),
        _react2.default.createElement(
          'section',
          { className: 'iw-banner' },
          _react2.default.createElement('img', {
            className: 'iw-banner__image',
            src: 'https://a.storyblok.com/f/42340/2000x666/0e6d3a9263/innovation_week.jpg',
            alt: 'Poverty Stoplight Innovation Week'
          })
        ),
        _react2.default.createElement(
          'main',
          { className: 'iw-content' },
          _react2.default.createElement(
            'h1',
            { className: 'iw-visually-hidden' },
            title,
            ': Poverty Stoplight Innovation Week, July 6\u201310, 2026'
          ),
          _react2.default.createElement(
            'div',
            { className: 'iw-intro' },
            _react2.default.createElement(
              'p',
              { className: 'iw-intro-text' },
              'Join us for an exciting',
              ' ',
              _react2.default.createElement(
                'strong',
                null,
                'week with the Global Stoplight Network'
              ),
              ' to discuss the latest trends in data and storytelling, technology and AI, and poverty elimination throughout the world.'
            ),
            _react2.default.createElement(
              'div',
              { className: 'iw-intro-pill iw-intro-pill--translation' },
              _react2.default.createElement(
                'span',
                { className: 'iw-intro-pill-line' },
                'Sessions in Spanish and English, with simultaneous translation in all events!'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'iw-intro-pill' },
              _react2.default.createElement(
                'span',
                { className: 'iw-intro-pill-line' },
                'Monday, July 6th \u2013 Friday, July 10th'
              ),
              _react2.default.createElement(
                'span',
                { className: 'iw-intro-pill-sub' },
                'Virtual & Open to the Public'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'iw-agenda' },
            AGENDA.reduce(function (acc, day, index) {
              var element = _this6.renderDay(day, 'agenda-day-' + index, acc.offset);
              acc.elements.push(element);
              acc.offset += day.sessions.length;
              return acc;
            }, { elements: [], offset: 0 }).elements
          )
        ),
        activeSession ? _react2.default.createElement(SessionLightbox, {
          session: activeSession,
          onClose: this.closeSession
        }) : null
      );
    }
  }]);

  return InnovationWeek;
}(_react2.default.Component);

exports.default = (0, _reactStatic.withRouteData)(InnovationWeek);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/InnovationWeek.f8acb706.js